import React, { createContext, useCallback, useContext, useMemo } from 'react';
import { useTranslation } from 'i18n';
import { t as translate } from './content/appMeta';

// Legal section dùng chung lang state với global LanguageProvider (mặc định EN
// — xem DEFAULT_LANG ở i18n/index.js; Meta App Review cần UI English).
// Giữ API `useLegalLang` để không phải refactor toàn bộ Legal pages — chỉ đổi
// `t` thành Legal-specific translator (đọc từ `appMeta.js`).
const LegalLangContext = createContext({
  lang: 'en',
  setLang: () => {},
  t: key => key,
});

export const LegalLangProvider = ({ children }) => {
  const { lang, setLang } = useTranslation();

  const t = useCallback(key => translate(key, lang), [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);

  return <LegalLangContext.Provider value={value}>{children}</LegalLangContext.Provider>;
};

export const useLegalLang = () => useContext(LegalLangContext);
